/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Team_Sync_Commit_Status_FailedInputs */



/**
* | output |
* | --- |
* | "Commit status failed: {message}" |
*
* @param {Team_Sync_Commit_Status_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_commit_status_failed = /** @type {((inputs: Team_Sync_Commit_Status_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Commit_Status_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l’état du commit : ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Commit-Status fehlgeschlagen: ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Stato di commit non riuscito: ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Статус фиксации: ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Estado de confirmación fallido: ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`提交状态失败：${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`コミットステータスに失敗しました: ${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`कमिट स्थिति विफल: ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Status da confirmação falhou: ${i?.message}`)
	return /** @type {LocalizedString} */ (`Commit status failed: ${i?.message}`)
});